module.exports = __webpack_public_path__ + "img/folder.e4ade6d9.svg";